/**
 * LaunchDarkly feature flag keys used by hsm-frontend.
 *
 * `FEATURE_SEGMENTS` is the SAME flag rapidash uses to gate its Segments
 * module: evaluating it here against the same LD environment keeps a single
 * source of truth for the rollout (dev=ON, stage=company-only, prod=OFF).
 */
export const FEATURE_SEGMENTS = 'feature-segments';

/** Usage breakdown by channel in Mensajes Salientes (roadmap#1899). */
export const FEATURE_HSM_USAGE_BY_CHANNEL = 'feature.hsm.usage-by-channel';

/** Conversation continuity + bot state options in campaign creation (roadmap#253). */
export const FEATURE_HSM_CAMPAIGN_CONTINUITY =
  'feature.253.hsm-campaign-continuity';

export const FEATURE_HSM_SEND_WITHOUT_BALANCE =
  'feature.2198.hsm-envio-sin-saldo';

export const FEATURE_HSM_RECONTACT_TEMPLATE =
  'feature.2273.plantilla-recontacto';

export const FEATURE_HSM_DEFAULT_MEDIA = 'feature.2404.hsm-default-media';
